import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api/client";
import { useAuth } from "./AuthContext";

const ProjectContext = createContext(null);
const LS_KEY = "ptt_project_id";

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [projectId, setProjectId] = useState(() => localStorage.getItem(LS_KEY) || "");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const [{ data: cRes }, { data: pRes }] = await Promise.all([
        api.get("/customers"),
        api.get("/projects"),
      ]);
      setCustomers(cRes.customers || []);
      const list = pRes.projects || [];
      setProjects(list);
      // Only Active projects are selectable in the tracker
      const activeList = list.filter((p) => p.status !== "Inactive");
      const savedOk = activeList.some((p) => p.id === projectId);
      if (!savedOk && activeList.length > 0) {
        setProjectId(activeList[0].id);
      } else if (activeList.length === 0) {
        setProjectId("");
      }
    } finally {
      setLoading(false);
    }
  }, [user]); // eslint-disable-line

  useEffect(() => { if (user) load(); }, [user, load]);

  useEffect(() => {
    if (projectId) localStorage.setItem(LS_KEY, projectId);
  }, [projectId]);

  const activeProjects = projects.filter((p) => p.status !== "Inactive");
  const project = projects.find((p) => p.id === projectId) || null;
  const customer = project ? customers.find((c) => c.id === project.customer_id) : null;

  return (
    <ProjectContext.Provider
      value={{ projects, activeProjects, customers, projectId, setProjectId, project, customer, loading, reload: load }}
    >
      {children}
    </ProjectContext.Provider>
  );
}

export const useProjects = () => useContext(ProjectContext);
